import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";
import Configs from "../../vendorConfigs/Configs";
import GameModel from "../../../core/src/model/GameModel";
import ConsoleUtil from "../../../core/src/utils/ConsoleUtil";

export default class LoginRequest implements IRequestBuilder {
    get method() {
      return "POST";
    }
  
    get path() {
        return Configs.game.clientConfig.gameServerApi + "/rmlogin";
    }
  
    get requestData() {
      let requestParams = {
        token: GameModel.playerToken,
        clientversion: GameModel.gameVersion,
        userid: GameModel.playerConfig.userId,
        mode: GameModel.mode,
        g: Configs.vendorServer.gameId,
        channel: GameModel.urlParams.channel || "web",
        partnerid: GameModel.partnerid,
        clientid: GameModel.urlParams.clientid || "",
        immediatePayouts: false,
        acceptFreespinsMidsession: true,
      };
  
      ConsoleUtil.log("[SBRequests] Login request:", requestParams);
  
      return requestParams;
    }
}